import * as types from "./actionTypes";
import * as riderNetworkApi from "../../api/riderNetworkApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function followUser(user) {
    return { type: types.NETWORK_FOLLOW_RIDER, user }
}

export function unfollowUser(user) {
    return { type: types.NETWORK_UNFOLLOW_RIDER, user }
}

export function removeFollowingUser(user) {
    return { type: types.NETWORK_REMOVE_FOLLOWING_RIDER, user }
}

export function blockUser(user) {
    return { type: types.NETWORK_BLOCK_RIDER, user }
}

export function unblockUser(user) {
    return { type: types.NETWORK_UNBLOCK_RIDER, user }
}

export function requestFollowUser(user) {
    return { type: types.NETWORK_REQUEST_FOLLOW_RIDER, user }
}

export function approveFollowerUserRequest(user) {
    return { type: types.NETWORK_APPROVE_FOLLOWER_RIDER, user }
}

export function rejectFollowerUserRequest(user) {
    return { type: types.NETWORK_REJECT_FOLLOWER_RIDER, user }
}

export function followRider(user, pending) {
    return dispatch => {
        dispatch(beginApiCall()); 
        return riderNetworkApi.follow(user)
            .then(() => {
                if (pending) {
                    dispatch(requestFollowUser(user));
                } else {
                    dispatch(followUser(user));
                }
                
                return user;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function unfollowRider(user) {
    return dispatch => {
        dispatch(beginApiCall()); 
        return riderNetworkApi.unfollow(user)
            .then(() => {
                dispatch(unfollowUser(user));
                return user;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function removefollowingRider(user) {
    return dispatch => {
        dispatch(beginApiCall()); 
        return riderNetworkApi.removeFollower(user)
            .then(() => {
                dispatch(removeFollowingUser(user));
                return user;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function blockRider(user) {
    return dispatch => {
        dispatch(beginApiCall()); 
        return riderNetworkApi.block(user)
            .then(() => {
                dispatch(blockUser(user));
                return user;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function unblockRider(user) {
    return dispatch => {
        dispatch(beginApiCall()); 
        return riderNetworkApi.unblock(user)
            .then(() => {
                dispatch(unblockUser(user));
                return user;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function getFollowRequests() {
    return dispatch => {
        dispatch(beginApiCall());
        return riderNetworkApi.getFollowRequests()
            .then((users) => {
                
                return users;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

/*
export function requestFollowRider(user) {
    return dispatch => {
        dispatch(beginApiCall()); 
        return riderNetworkApi.requestFollow(user)
            .then(() => {
                dispatch(requestFollowUser(user));
                return user;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}
*/

export function approveFollowerRequest(user) {
    return dispatch => {
        dispatch(beginApiCall()); 
        return riderNetworkApi.approveFollower(user)
            .then(() => {
                dispatch(approveFollowerUserRequest(user));
                return user;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function rejectFollowerRequest(user) {
    return dispatch => {
        dispatch(beginApiCall());
        return riderNetworkApi.rejectFollower(user)
            .then(() => {
                dispatch(rejectFollowerUserRequest(user));
                return user;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/riderNetworkActions.js